import { render, staticRenderFns } from "./OfferStatistics.vue?vue&type=template&id=28150638"
import script from "./OfferStatistics.vue?vue&type=script&lang=ts"
export * from "./OfferStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports